import type { Question, Survey } from "@pulse/api/surveyApi";
import { createContext } from "react";

export type SurveyStepType = "start" | "question" | "complete";

type SurveyLayoutCtx = {
    stepType: SurveyStepType;
    setStepType: (stepType: SurveyStepType) => void;
    currentQuestionIndex: number;
    setCurrentQuestionIndex: (index: number) => void;
    isLoading: boolean;
    startSurvey?: () => void;
    handlePrevious?: () => void;
    handleNext?: () => void;
    survey: Survey | undefined;
    questions: Question[] | undefined;
    isPreview: boolean;
};

export const SurveyLayoutContext = createContext<SurveyLayoutCtx | null>(null);
